import React from 'react';

import { createStyles, makeStyles } from '@material-ui/core';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import PropTypes from 'prop-types';
import { ButtonStyle, ButtonStyleOutline } from './styles';

export const useStyles = makeStyles(() =>
  createStyles({
    rotateIcon: {
      animation: '$spin 2s linear infinite',
    },
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(360deg)',
      },
      '100%': {
        transform: 'rotate(0deg)',
      },
    },
  }),
);

function Base({
  type = 'primary',
  label = 'Button',
  color = `var(--color-blue-primary)`,
  width = '100%',
  margin = null,
  onClick = async () => {},
  isLoading = false,
  disable = false,
  padding,
}) {
  const classes = useStyles();

  const handleClick = async () => {
    if (onClick) {
      await onClick();
    }
  };

  if (type === 'outline') {
    return (
      <ButtonStyleOutline
        color={color}
        width={width}
        margin={margin}
        onClick={handleClick}
        disabled={disable || isLoading}
        padding={padding}
      >
        {!isLoading ? label : <RotateLeftIcon className={classes.rotateIcon} />}
      </ButtonStyleOutline>
    );
  }

  return (
    <ButtonStyle
      color={color}
      type="submit"
      width={width}
      margin={margin}
      onClick={handleClick}
      padding={padding}
      disabled={disable}
    >
      {!isLoading ? label : <RotateLeftIcon className={classes.rotateIcon} />}
    </ButtonStyle>
  );
}

function Normal(props) {
  return Base({ ...props });
}

function Small(props) {
  return Base({ ...props, padding: '6px 10px' });
}

export const ButtonPrimary = {
  Normal,
  Small,
};

Normal.propTypes = Small.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disable: PropTypes.bool,
};
